<script setup lang="ts">
  import { PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from 'radix-vue'
  import type { IPopover } from '@/components/ui/popover/types'

  withDefaults(defineProps<IPopover>(), {
    label: 'label',
    side: 'bottom',
    offset: 10,
    showArrow: false,
    hasOverlay: false,
    arrowColor: 'fill-white',
    arrowHeight: 5,
    arrowWidth: 10,
    closeManually: false
  })

  const { isMobile } = useBTBreakpoints()

  const isOpen = defineModel<boolean>()
</script>

<template>
  <div :class="{ 'relative z-30': isOpen, 'popover-overlay': hasOverlay }">
    <PopoverRoot
      v-model:open="isOpen"
      @update:open="isOpen = $event"
    >
      <PopoverAnchor v-if="$slots.anchor">
        <slot name="anchor" />
      </PopoverAnchor>
      <PopoverTrigger
        v-if="$slots.trigger"
        :aria-label="label"
      >
        <slot name="trigger" />
      </PopoverTrigger>
      <PopoverPortal disabled>
        <PopoverContent
          :side="side"
          :side-offset="offset"
          @focus-outside="(e) => closeManually && e.preventDefault()"
          @interact-outside="(e) => closeManually && e.preventDefault()"
          @click.stop
        >
          <slot name="content" />

          <LazyPopoverClose
            v-if="hasOverlay && isMobile"
            aria-label="Close"
            as-child
          >
            <slot name="close">
              <div class="absolute right-5 top-5 size-6">
                <Icon name="common/close" />
              </div>
            </slot>
          </LazyPopoverClose>
          <LazyPopoverArrow
            v-if="showArrow"
            :class="arrowColor"
            :width="arrowWidth"
            :height="arrowHeight"
          />
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>
  </div>
</template>

<style lang="scss" scoped>
  .popover-overlay {
    [data-radix-popper-content-wrapper] {
      @media (max-width: theme('screens.sm')) {
        @apply fixed h-full max-h-none w-full max-w-none transform-none #{!important};
      }
    }
  }
</style>
